export const initialState = {};
export const initialResourceState = {
  segment: '',
  advertiserId: '',
  query: {
    sql: '',
    deviceCount: 0,
  },
};

export const getAudiences = (state = initialState) => state.audiences | initialResourceState;

export const getTtdPost = (state = initialState) => {
  const audiences = getAudiences(state);
  return {
    query: audiences.query,
    metadata: {
      segment: audiences.deviceGroupName,
      advertiserId: audiences.advertiserId,
      daidColumn: 'devices',
    },
  };
};
